type ResolveFromDateParams = {
  fromDate?: Date;
  disablePast?: boolean;
  disableToday?: boolean;
};

export function resolveFromDate({
  fromDate,
  disablePast,
  disableToday,
}: ResolveFromDateParams): Date | undefined {
  if (fromDate) return fromDate;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (disableToday) {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow;
  }

  if (disablePast) return today;

  return undefined;
}
